/**
 * Not using `mapbox-gl` becuase we need to support IE9
 */

import mapbox from "mapbox.js";
import leafletPip from "leaflet-pip";
import numeral from "numeral";

import sanitizeCountryName from "../utilities/sanitize-country-name";
import formatNumber from "../utilities/format-number";

const countryGeoCodes = require("../../../data-assets/geocodes/country_geocodes.json");

function usgcMap() {
    if (!document.querySelector("#usgc-countries")) return;

    L.mapbox.accessToken =
        "pk.eyJ1IjoidXNnYyIsImEiOiJjamNncDR2bGcxdHh2MndtdGZqNjU5dGw4In0.Izbw1rDP8mqblnqcuUom0Q";

    const mgApi = "/wp-json/mg/v1/",
        southWest = L.latLng(-70.875404, -157.848693),
        northEast = L.latLng(84.555321, 158.512757),
        bounds = L.latLngBounds(southWest, northEast);

    //color schemes
    const defaultScheme = {
            color: "#7ed0e0",
            fillColor: "#003e7e",
            fillOpacity: 1,
            opacity: 1,
            weight: 1
        },
        hoverAndActive = {
            color: "#d18316",
            fillColor: "#d18316",
            fillOpacity: 1,
            opacity: 1,
            weight: 1
        };

    const map = L.mapbox
        .map("usgc-countries", null, {
            maxBounds: bounds,
            maxZoom: 5,
            minZoom: 1
        })
        .setView([30.90222470517144, -9.492187500000002], 2);

    let worldLayer,
        countryMarkers = [],
        worldExportData = [];

    /**
     * If adding a layer use this format:
     *
     * { name: "Layer Name", layer: THE_FEATURE_LAYER }
     *
     */
    let mapLayers = [];

    /**
     * Disable map zoom when using scroll
     */
    map.scrollWheelZoom.disable();

    function clickMarker(e) {
        const props = e.layer.feature.properties;
        console.log(props);

        location.href = `/markets-tools-data/tools/feed-grains-in-all-forms-portal/?location=${
            props.title
        }`;
    }

    function getMarketData() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${mgApi}market-data`
            }).then(
                response => {
                    response.forEach(item => {
                        let cleanCountryName = item.market_name;

                        cleanCountryName = sanitizeCountryName(
                            cleanCountryName
                        );

                        let currentYearQuantity = formatNumber(
                                item.all.current_market_year_quantity
                            ),
                            currentYearValue = formatNumber(
                                item.all.current_market_year_value
                            ),
                            obj = {
                                name: cleanCountryName,
                                longitude: null,
                                latitude: null,
                                id: item.id,
                                stat: `Qty: ${currentYearQuantity}<br> Value: $${currentYearValue}`
                            };

                        if (countryGeoCodes[cleanCountryName]) {
                            obj.longitude =
                                countryGeoCodes[cleanCountryName]["long"];
                            obj.latitude =
                                countryGeoCodes[cleanCountryName]["lat"];

                            worldExportData.push(obj);
                        }
                    });

                    resolve();
                },
                error => {
                    console.log("There was a problem retrieving Market Data");
                    reject();
                }
            );
        });
    }

    function MapMarkers(worldExportData) {
        if (!worldExportData) return;

        const markerLayer = L.mapbox.featureLayer().addTo(map);

        $.each(worldExportData, function(index, item) {
            /**
             * https://www.mapbox.com/help/markers-js/#add-markers-with-geojson-in-mapboxjs
             */
            const marker = {
                type: "Feature",
                geometry: {
                    type: "Point",
                    // coordinates here are in longitude, latitude order because
                    // x, y is the standard for GeoJSON and many formats
                    coordinates: [item.longitude, item.latitude]
                },
                properties: {
                    title: item.name,
                    description: item.stat,
                    id: item.id,
                    icon: {
                        className: "mg-map-pin", // class name to style
                        html: `<svg class="mg-icon mg-icon--medium filter-shadow-sm"><use href="#icon-location" xlink:href="#icon-location"/></svg>`, // add content inside the marker
                        iconSize: [32, 32]
                    }
                }
            };

            countryMarkers.push(marker);
        });

        markerLayer
            .on("layeradd", function(e) {
                var marker = e.layer,
                    feature = marker.feature;
                marker.setIcon(L.divIcon(feature.properties.icon));
            })
            .on("click", clickMarker)
            .on("mouseover", function(e) {
                e.layer.openPopup();
            })
            .on("mouseout", function(e) {
                e.layer.closePopup();
            })
            .on("mouseover", function(e) {
                e.layer.openPopup();
            });

        markerLayer.setGeoJSON(countryMarkers);
    } //MapMarkers

    function styleCountries() {
        var layersObj = worldLayer._layers,
            layersArray = $.map(layersObj, function(value, index) {
                return [value];
            });

        $.each(layersArray, function(i) {
            layersArray[i].setStyle(defaultScheme);
        });
    }

    function countryClick(e) {
        // look through each layer in order and see if the clicked point,
        // e.latlng, overlaps with one of the shapes in it.
        for (var i = 0; i < mapLayers.length; i++) {
            const match = leafletPip.pointInLayer(
                // the clicked point
                e.latlng,
                // this layer
                mapLayers[i].layer,
                // whether to stop at first match
                true
            );

            if (match.length) {
                const matchProps = match[0].feature.properties;
                console.log(matchProps);
            }
        }
    }

    function loadWorld() {
        worldLayer = L.mapbox
            .featureLayer()
            .loadURL("/wp-content/themes/usgc/data-assets/geojson/countries.js")
            .on("ready", styleCountries)
            .on("click", countryClick)
            .addTo(map);

        mapLayers.push({ name: "Countries", layer: worldLayer });
    }

    function init() {
        loadWorld();
        getMarketData().then(() => {
            MapMarkers(worldExportData);
        });
    }

    init();
}

export default function() {
    $(function() {
        usgcMap();
    });
}



// WEBPACK FOOTER //
// ./src/js/partials/map.js